import { useCompanyStore } from '@/stores/company';
const { company } = useCompanyStore();
import { computed } from 'vue';

const getImageLanguage = computed(() =>
  company.language === 'nl' ? 'nl' : 'en',
);

export default getImageLanguage;
